import { Position } from "@react-pdf-viewer/core";

type ModalTextButtonProps = {
  title: string; 
  buttonName: string;
   visible:boolean;
    subtitle?: string;
  buttonColor?: string;
  onClick?: () => void;
  onClose?: () => void;
 
};

const ModalTextButton: React.FC<ModalTextButtonProps> = ({
  title,
  subtitle,
  visible,
  buttonName,
  buttonColor,
  onClick,
  onClose
}) => {


      
  const styles = {
    modalContainer: {
        display: visible? 'block' :'none' ,
      padding: '24px',
      width: 'fit-content',
      borderRadius: '12px',
      backgroundColor: '#fff',  
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
      textAlign: 'center' as const,
      fontFamily: 'Arial, sans-serif',
      position: 'fixed' as const,  
      left:'50%',
      top:'50%', 
      transform: 'translate(-50%, -50%)',


    },
    title: {
      fontSize: '24px',
      fontWeight: 'bold' as const,
      marginBottom: subtitle ? '8px' : '16px',
    },
    subtitle: {
      fontSize: '16px',
      color: '#555',
      marginBottom: '16px',
    },
    button: {
      padding: '12px 24px',
      border: 'none',
      borderRadius: '6px',
      backgroundColor: buttonColor || 'seagreen',
      color: '#fff',
      fontSize: '16px',
      cursor: 'pointer',
      transition: 'background 0.3s',
    },
  };


  return (
    <div style={styles.modalContainer}>
          <div className="close_button" onClick={onClose}>X</div>
      <h3 style={styles.title}>{title}</h3>
      {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
      <button style={styles.button} onClick={onClick}>
        {buttonName}
      </button>
    </div>
  );






};


export default ModalTextButton;
